import { authGet } from "@api/auth/auth";

interface GetEmailSettingsResponse {
  email: string;
  subscribed: boolean;
  contact_about_experiments: boolean;
}

export const fetchUserEmailSettings = (): Promise<GetEmailSettingsResponse> => {
  let url = `/api/user/emails`;
  return authGet<GetEmailSettingsResponse>(url);
};
